<template>
    <div class="body-ball"
         @mousemove.stop="mouseMove"
         @mouseup.stop="mouseUp">
        <div class="ball"
             @click="submit"
             @mousedown.stop="mouseDown"
             @mouseup.stop="mouseUp">
        </div>
    </div>
</template>

<script>

export default {
    name: "BallCreate",
    data(){
        return {
            ball: {},

            dragging: false,
            moveState: false,
            offsetX: 0, // 初始位置
            offsetY: 0, // 初始位置
            midline: 0, // 中心线
            padding: {
                left: 0,
                right: 0,
                top: 0,
            }, // 内边距
        }
    },
    methods: {
        submit: function(){
            if(this.moveState){
                this.moveState = false;
            }else{
                this.$emit("submitEvent");
            }
        },
        /**
         * 按下
         * @param e
         */
        mouseDown: function(e){
            // 设置拖动区域
            e.target.parentNode.style.width = "100%";
            e.target.parentNode.style.height = "100%";
            e.target.parentNode.style.position = "absolute";


            this.ball = e.target;

            // 球的坐标
            this.offsetX = e.clientX - this.ball.offsetLeft;
            this.offsetY = e.clientY - this.ball.offsetTop;

            // 移动状态
            this.dragging = true;
            // 动画
            this.ball.style.transition = 'none';
            // 中心先
            this.midline = parseInt(this.ball.parentNode.offsetWidth / 2);
            // 内边距
            if(this.padding.left === 0){
                this.padding.left = this.ball.parentNode.offsetWidth - this.ball.offsetLeft - this.ball.clientWidth;
                this.padding.right = this.ball.offsetLeft;
                this.padding.top = this.ball.offsetTop;
            }

        },
        /**
         * 移动
         * @param e
         */
        mouseMove: function(e){
            if(this.dragging){
                let left, top;
                left = e.clientX - this.offsetX;
                top = e.clientY - this.offsetY;
                this.ball.style.left = left + "px";
                this.ball.style.top = top+"px";
                this.moveState = true;
            }
        },
        /**
         * 抬起
         * @param e
         */
        mouseUp: function(e){
            this.ball.style.transition = '.5s ease-in-out';
            let left = 0;
            if(this.midline > parseInt(this.ball.style.left)){
                // 靠左
                left = this.padding.left;
            }else{
                // 靠右
                left = this.padding.right;
            }

            if(this.padding.left > parseInt(this.ball.style.top)){
                // 靠上
                this.ball.style.top = this.padding.left + "px";
            }else if(this.padding.top < parseInt(this.ball.style.top)){
                // 靠下
                this.ball.style.top = this.padding.top + "px";
            }
            this.ball.style.left = left + "px";
            this.dragging = false;
            e.target.parentNode.style.width = "0";
            e.target.parentNode.style.height = "0";
            e.target.parentNode.style.position = null;
        }
    },
}
</script>

<style scoped>
div.body-ball{
    left: 0;
    overflow: hidden;
    z-index: 10;
}

div.ball{
    width: 0.72rem;
    height: 0.72rem;
    background: url("../../../assets/images/List/icon-matter-create.png");
    background-size: cover;
    position: absolute;
    left: calc(100% - 0.2rem - 0.72rem);
    top: calc(100% - 0.2rem - 0.72rem);
    cursor: pointer;
    z-index: 10;

}
</style>